import { combineReducers } from 'redux';
import displayedGroupsSettings from './displayed-groups-modal/reducer';
export default combineReducers({
    displayedGroupsSettings,
});
